<template>
  <section v-if="showList" class="drawer-list__container">
    <WParagraph v-if="title" class="drawer-list__title" size="small">
      {{ title }} <span v-if="total">({{ total }})</span>
    </WParagraph>

    <CEmptyState
      v-if="showOfflineMessage"
      :icon="offlineState.icon"
      :message="offlineState.message"
      size="xsmall"
      class="drawer-list__offline"
    >
      <WLink
        class="drawer-list__offline__button"
        quiet
        size="small"
        @click="changeStaffStatus"
      >
        Atualizar status para online
      </WLink>
    </CEmptyState>

    <template v-if="list && list.length">
      <component
        :is="listItemComponent"
        v-for="channel in list"
        :key="channel.id"
        :is-emergency="isEmergency"
        :channel="channel"
        @go-to-pillars="$emit('goToPillars')"
      />
    </template>

    <CEmptyState
      v-else-if="!showOfflineMessage"
      size="xsmall"
      :icon="emptyIcon"
      :title="currentEmptyMessage"
    />
  </section>
</template>

<script>
import { WLink, WParagraph } from '@alice-health/wonderland-vue'
import { mapGetters, mapState } from 'vuex'

import { CEmptyState } from '@/components/channels/atoms'
import { STAFF_STATUS } from '@/models/channels'

import { PSidenavListItemCompact, PSidenavListItemExpanded } from '../'

export default {
  components: {
    PSidenavListItemCompact,
    PSidenavListItemExpanded,
    CEmptyState,
    WLink,
    WParagraph
  },
  inject: ['notify'],
  props: {
    list: { type: [Array, undefined], default: undefined },
    title: { type: String, default: undefined },
    hideNoResults: Boolean,
    isEmergency: Boolean,
    emptyIcon: { type: String, default: undefined },
    emptyMessage: {
      type: String,
      default: 'Nenhuma novidade nos seus canais'
    },
    total: {
      type: Number,
      default: 0
    },
    showOfflineMessage: {
      type: Boolean
    }
  },
  emits: ['goToPillars'],
  computed: {
    ...mapGetters('ui/channelBar', ['isMenuExpanded']),
    ...mapGetters('channel/staff', ['loggedStaff']),
    ...mapState('channel/drawer', ['currentFilters']),
    currentEmptyMessage() {
      return this.currentFilters.tags?.length && !this.list?.length
        ? 'Nenhum resultado encontrado'
        : this.emptyMessage
    },
    showList() {
      if (this.showOfflineMessage) return true
      if (this.hideNoResults) return this.list?.length
      return this.list !== undefined
    },
    listItemComponent() {
      if (this.isMenuExpanded) return 'PSidenavListItemExpanded'
      return 'PSidenavListItemCompact'
    },
    offlineState() {
      return this.loggedStaff.status === STAFF_STATUS.BUSY
        ? {
            icon: 'exclamation',
            message: 'Novos atendimentos em volume reduzido'
          }
        : {
            icon: 'x',
            message: 'Você não está recebendo novos atendimentos'
          }
    }
  },
  methods: {
    async changeStaffStatus() {
      const result = await this.$store.dispatch(
        'channel/staff/setLoggedStaffStatus',
        STAFF_STATUS.AVAILABLE
      )
      if (result)
        this.notify({
          description: 'Status atualizado',
          icon: 'icCheckOutlined',
          duration: 2000
        })
    }
  }
}
</script>

<style lang="scss">
@import '@/style/_non-rendering';
.drawer-list {
  &__container {
    padding: var(--gl-spacing-04) 0;
  }

  &__title {
    @extend %overline-default;
    color: var(--gl-color-shades-gray-60);
    margin: var(--gl-spacing-06) 0;
  }

  &__offline {
    margin-bottom: var(--gl-spacing-04);
    &__button {
      display: flex;
      margin-top: var(--gl-spacing-04);
    }
  }
}
</style>
